import { formatTime, formatMs } from "../utils";

export default function TimelineEvent({ event, color, isLast, showRain }) {
  return (
    <div className={`timeline-event ${showRain ? "matrix-glow-subtle" : ""}`}>
      <div
        className="timeline-marker"
        style={{ background: color, boxShadow: showRain ? `0 0 10px ${color}` : "none" }}
      />
      {!isLast && (
        <div
          className="timeline-line"
          style={{
            background: showRain ? `linear-gradient(180deg, ${color}40, transparent)` : undefined,
          }}
        />
      )}
      <div className="timeline-content">
        <div className="timeline-time">{formatTime(event.ts || event.start_ts)}</div>
        <div className="timeline-message">
          {event.step && (
            <span className="timeline-step" style={{ background: `${color}20`, color }}>
              {event.step}
            </span>
          )}
          <span className="timeline-text">{event.message || event.action || event.status}</span>
          {event.duration_ms !== undefined && (
            <span className="timeline-duration">{formatMs(event.duration_ms)}</span>
          )}
        </div>
        {event.extra && (
          <div className="timeline-extra">
            {Object.entries(event.extra)
              .slice(0, 3)
              .map(([k, v]) => (
                <span key={k} className="timeline-tag">
                  {k}: {(() => {
                    if (typeof v === "number") {
                      return v.toFixed?.(2) ?? v;
                    }
                    return String(v).slice(0, 30);
                  })()}
                </span>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}
